export default {
    state: () => ({
        data: { }
    }),
    mutations: {
        ['cities/setState'](state, payload) {
            state.data = {
                ...payload,
            };
        }
    },
    actions: {
        async ['cities/setCity']({ state: { data }, commit }, city ) {
            try {
                const { path, action, LANGUAGE_ID } = data?.routes?.setCity;
                const requestParams = { action, city, LANGUAGE_ID };

                const { status, data: responseData } = await axios.post(path, requestParams);
                if (status !== 200) {
                    throw `set default city bad response status ${status}`
                }
                // console.log(responseData);
                commit('cities/setState', responseData);
            } catch (err) {
                console.error(err);
            }
        },
        async ['cities/getCities']({ state: { data }, commit }, city ) {
            try {
                const { path, action, LANGUAGE_ID } = data?.routes?.getCities;
                const requestParams = {
                    action,
                    city,
                    LANGUAGE_ID
                };

                const { status, data: responseData } = await axios.post(path, requestParams);
                if (status !== 200) {
                    throw `set default city bad response status ${status}`
                }

                commit('cities/setState', {
                    ...data,
                    cities: [...responseData.cities]
                });
            } catch (err) {
                console.error(err);
            }
        },
        async ['cities/getCitiesWithShops']({ state: { data }, commit }, city ) {
            try {
                const { path, action, LANGUAGE_ID } = data?.routes?.getCities;
                const requestParams = {
                    findOnlyForStores: true,
                    action,
                    city,
                    LANGUAGE_ID
                };

                const { status, data: responseData } = await axios.post(path, requestParams);
                if (status !== 200) {
                    throw `set default city bad response status ${status}`
                }

                commit('cities/setState', {
                    ...data,
                    cities: [...responseData.cities]
                });
            } catch (err) {
                console.error(err);
            }
        },
        async ['cities/getWarehouses']({ state, commit }, { UF_XML_ID , warehouse }) {
            try {
                const { action, path, LANGUAGE_ID } = state.data?.routes?.getWarehouses;

                const { data, status } = await axios.get(path, {
                    params: {
                        action,
                        city: UF_XML_ID,
                        warehouse,
                        LANGUAGE_ID
                    }
                });

                if (status !== 200) throw `bad request response status: ${ status }`;

                // const { warehouses } = data;
                // console.log(warehouses);
                if (data.warehouses) {
                    commit('cities/setState', {
                        ...state.data,
                        ...data,
                    })
                }
            } catch (err) {
                console.error(err);
            }
        }
    },
    getters: {
        ['cities/id']: ({ data: { userCity } }) => {
            return userCity?.ID;
        },
    }
}
